const Bgpolygon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="516"
      height="620"
      viewBox="0 0 516 620"
      fill="none"
    >
      <path
        d="M177.192 -237.36C180.128 -251.501 196.625 -257.963 208.385 -249.579L993.103 309.91C1006.78 319.658 1003.07 340.898 986.911 345.447L30.1102 614.721C15.6686 618.786 2.05969 606.093 5.10974 591.403L177.192 -237.36Z"
        stroke="#310F21"
        stroke-width="8"
      />
    </svg>
  );
};

export default Bgpolygon;
